import { renderToStaticMarkup } from "react-dom/server";
import { allFixtures, allFloorItems, type PlanLayers } from "@/shared/plan";
import { MaterialDefs } from "@/widgets/catalog";
import { buildRoomElevations, detectRooms, roomTitle } from "@/widgets/plan";
import { layoutElevations } from "@/widgets/wall-elevations/logic";
import { ElevationSheet } from "@/widgets/wall-elevations/ui/ElevationSheet";
import type { PrintSvgPage } from "./printDocument";

const svgFromMarkup = (markup: string) => {
	const svg = new DOMParser().parseFromString(markup, "image/svg+xml").documentElement;
	if (svg.tagName.toLowerCase() !== "svg") throw new Error("Не удалось собрать SVG развёртки.");
	// Стены рендерятся по очереди. Выносим мебель поверх всей ленты, чтобы заливка или
	// проём соседней стены не мог закрыть её часть на стыке развёрток.
	for (const item of svg.querySelectorAll("[data-elevation-floor-item]")) svg.append(item);
	return svg as unknown as SVGSVGElement;
};

/** Собирает по одному векторному листу развёрток для каждого помещения. */
export const elevationPages = (layers: PlanLayers): PrintSvgPage[] =>
	detectRooms(layers.walls).map((room, index) => {
		const layout = layoutElevations(
			buildRoomElevations(layers.walls, allFixtures(layers), room, allFloorItems(layers)),
		);
		const { minX, minY, maxX, maxY } = layout.bounds;
		return {
			title: `Развёртки · ${roomTitle(layers.rooms, room.id, index)}`,
			svg: svgFromMarkup(
				renderToStaticMarkup(
					<svg
						viewBox={`${minX} ${minY} ${maxX - minX} ${maxY - minY}`}
						preserveAspectRatio="xMidYMid meet"
					>
						<MaterialDefs mmPerPx={6} />
						{layout.sheets.map((sheet) => (
							<ElevationSheet
								key={sheet.elevation.wallId}
								sheet={sheet}
								mmPerPx={6}
								selection={null}
								interactive={false}
								showDimensions
								fillWallFace={false}
								onFixturePointerDown={() => {}}
								onFloorItemPointerDown={() => {}}
								onWallPointerDown={() => {}}
							/>
						))}
					</svg>,
				),
			),
		};
	});
